// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#openbay .location-selector{padding:2rem 1rem}#openbay .txt-divider{display:flex;align-items:center;text-align:center}#openbay .txt-divider:after,#openbay .txt-divider:before{content:\"\";flex:1;border-bottom:1px solid #e5e8ed}#openbay .txt-divider:not(:empty):before{margin-right:1em}#openbay .txt-divider:not(:empty):after{margin-left:1em}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
